import { render } from "./StatisticsOverview.vue?vue&type=template&id=6c31f7a9"
import script from "./StatisticsOverview.vue?vue&type=script&lang=js"
export * from "./StatisticsOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__